<script setup lang="ts">
import { inject, onMounted, ref } from 'vue';

const video = ref(null);

const siteAddress = inject('siteAddress');

onMounted(() => {
  const el = video.value;
  const source = el.querySelector('source');

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          if (!source.src) {
            source.src = source.dataset.src;
            el.load();
          }

          el.play().catch(() => {
            console.log('Video could not play.');
          });
          observer.disconnect();
        }
      });
    },
    { threshold: 0.5 }
  );

  observer.observe(el);
});
</script>

<template>
  <section id="Earrings" class="earrings-section">
    <div class="bg-effect"></div>

    <div class="container content">
      <div class="row items-center">
        <!-- TEXT -->
        <div class="col-12 col-md-6 text-content">
          <h2 class="title">Zamansız Küpelerle Işılda</h2>
          <p class="subtitle">Her anına zarafet katacak özel tasarımlar.</p>
          <div class="q-pt-md explore-btn-wrapper">
            <q-btn
              :href="`${siteAddress}/kupeler`"
              label="Küpeleri Keşfet"
              unelevated
              rounded
              class="explore-btn q-px-xl q-py-sm text-weight-medium"
            />
          </div>
        </div>

        <!-- VIDEO -->
        <div class="col-12 col-md-6 video-content-wrapper">
          <div class="video-content">
            <q-no-ssr>
              <video ref="video" muted playsinline loop preload="none" poster="/images/thumb.jpg" class="video">
                <source data-src="/vids/5303524-hd_1920_1080_30fps.webm" type="video/mp4" />
              </video>
            </q-no-ssr>
          </div>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped>
.earrings-section {
  position: relative;
  overflow: hidden;
  padding: 100px 0;
  color: white;
}

/* 🔥 Glow Background */
.bg-effect {
  position: absolute;
  width: 600px;
  height: 600px;
  background: radial-gradient(circle, #ff7eb3, #7afcff, #feff9c);
  filter: blur(120px);
  opacity: 0.6;
  border-radius: 50%;
  top: -150px;
  left: -150px;
  animation: moveGlow 12s infinite alternate ease-in-out;
}

/* ikinci glow (derinlik için) */
.bg-effect::after {
  content: '';
  position: absolute;
  width: 500px;
  height: 500px;
  background: radial-gradient(circle, #a18cd1, #fbc2eb);
  filter: blur(120px);
  border-radius: 50%;
  bottom: -200px;
  right: -200px;
  animation: moveGlow2 15s infinite alternate ease-in-out;
}

/* içerik üstte kalsın */
.content {
  position: relative;
  z-index: 2;
}

/* TEXT */
.title {
  font-size: 42px;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 1.2;
  color: #0f0f14;
}

.subtitle {
  font-size: 18px;
  opacity: 0.8;
  color: rgba(15, 15, 20, 0.71);
}

.explore-btn {
  background: #0f0f14;
  color: #ffffff;
  font-size: 16px;
  transition: all 0.3s ease;
}

.explore-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 10px 20px rgba(15, 15, 20, 0.2);
}

/* Desktop Video styling handled via media queries to create seamless fade */

/* ANIMATIONS */
@keyframes moveGlow {
  0% {
    transform: translate(0, 0) scale(1);
  }
  100% {
    transform: translate(200px, 150px) scale(1.2);
  }
}

@keyframes moveGlow2 {
  0% {
    transform: translate(0, 0) scale(1);
  }
  100% {
    transform: translate(-150px, -100px) scale(1.3);
  }
}

/* RESPONSIVE & SEAMLESS FADE INTEGRATION */
@media (min-width: 768px) {
  .video-content-wrapper {
    position: static;
  }
  .video-content {
    position: absolute;
    top: 0;
    right: 0;
    bottom: 0;
    width: 55%;
    z-index: 1; /* behind content container */
    overflow: hidden;
    border-radius: 10px;
  }
  .video {
    width: 100%;
    height: 100%;
    object-fit: cover;
    -webkit-mask-image: linear-gradient(to right, transparent 0%, black 25%);
    mask-image: linear-gradient(to right, transparent 0%, black 25%);
  }
}

@media (max-width: 1024px) and (min-width: 768px) {
  .video-content {
    width: 60%;
  }
}

@media (max-width: 767px) {
  .earrings-section {
    padding: 60px 0;
  }

  .text-content {
    text-align: center;
    margin-bottom: 40px;
  }

  .title {
    font-size: 32px;
  }

  .video-content {
    position: relative;
    right: auto;
    display: flex;
    justify-content: center;
    padding: 1rem;
    display: none;
  }

  .video {
    max-width: 100%;
    border-radius: 12px;
  }

  .bg-effect {
    width: 300px;
    height: 300px;
  }

  .bg-effect::after {
    width: 250px;
    height: 250px;
    bottom: -100px;
    right: -100px;
  }
}
</style>
